import type { ReactElement, ReactNode } from 'react'

import { jsx } from '@emotion/react'
import { isNil } from 'ramda'

// reused from here: https://github.com/emotion-js/emotion/issues/1404#issuecomment-504527459
export const cloneElement = (
  element: ReactElement,
  config: Record<string, unknown>,
  ...children: ReactNode[]
) =>
  jsx(
    !isNil(element.props.__EMOTION_TYPE_PLEASE_DO_NOT_USE__)
      ? element.props.__EMOTION_TYPE_PLEASE_DO_NOT_USE__
      : element.type,
    {
      key: element.key !== null ? element.key : undefined,
      ...element.props,
      ...config,
    },
    ...children
  )
